/**
 * Custom modal handler to prevent closing on click of modal-background.
 */

class ModalHandler {
  constructor(modalSelector) {
    // Check if modalSelector is already an HTMLElement
    this.modal = modalSelector instanceof HTMLElement
      ? modalSelector
      : document.querySelector(modalSelector);

    this.init();
    return this.modal;
  }

  init() {
    if (this.modal) {
      const modalBackground = this.modal.querySelector('.modal-background');
      if (modalBackground) {
        modalBackground.style.pointerEvents = 'none';
      }
    }
  }
}

export default ModalHandler;
